// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.pageRoot[data-v-4a99eb3c]
	{
		margin: 8px;
}
.loading[data-v-4a99eb3c]
	{
		margin-top: 80px;
		text-align: center;
}
.error[data-v-4a99eb3c]
	{
		color: #FF0000;
		font-weight: bold;
}
`, "",{"version":3,"sources":["webpack://./www/vues/client/ClientServerInfo.vue"],"names":[],"mappings":";AA4CC;;EAEC,WAAW;AACZ;AAEA;;EAEC,gBAAgB;EAChB,kBAAkB;AACnB;AAEA;;EAEC,cAAc;EACd,iBAAiB;AAClB","sourcesContent":["<template>\r\n\t<div :class=\"{ pageRoot: true }\">\r\n\t\t<div v-if=\"error\" class=\"error\">{{error}}</div>\r\n\t\t<div v-else-if=\"loading\" class=\"loading\"><ScaleLoader /> Loading…</div>\r\n\t\t<div v-else>\r\n\t\t\tThis page is not implemented.\r\n\t\t</div>\r\n\t</div>\r\n</template>\r\n\r\n<script>\r\n\r\n\texport default {\r\n\t\tcomponents: {},\r\n\t\tprops:\r\n\t\t{\r\n\t\t\tserverName: {\r\n\t\t\t\ttype: String,\r\n\t\t\t\tdefault: \"\"\r\n\t\t\t}\r\n\t\t},\r\n\t\tdata()\r\n\t\t{\r\n\t\t\treturn {\r\n\t\t\t\terror: null,\r\n\t\t\t\tloading: false\r\n\t\t\t};\r\n\t\t},\r\n\t\tcreated()\r\n\t\t{\r\n\t\t},\r\n\t\tcomputed:\r\n\t\t{\r\n\t\t},\r\n\t\tmethods:\r\n\t\t{\r\n\t\t},\r\n\t\twatch:\r\n\t\t{\r\n\t\t}\r\n\t}\r\n</script>\r\n\r\n<style scoped>\r\n\t.pageRoot\r\n\t{\r\n\t\tmargin: 8px;\r\n\t}\r\n\r\n\t.loading\r\n\t{\r\n\t\tmargin-top: 80px;\r\n\t\ttext-align: center;\r\n\t}\r\n\r\n\t.error\r\n\t{\r\n\t\tcolor: #FF0000;\r\n\t\tfont-weight: bold;\r\n\t}\r\n</style>"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
